// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"16c042ea","769":"599e6016"}[chunkId] + ".chunk.js";
};